import { ParticipantDocument } from "@/apis/dtos";
import { createContext } from "react";

const ParticipantDocumentContext = createContext<ParticipantDocument | null>(null);

export default ParticipantDocumentContext;